import config from "../../config.json"

export const getUserInfo = async (token) => {
    var myHeaders = new Headers();
    myHeaders.append("Access-Token", token ?? "");
    myHeaders.append("Cache-Control", "no-cache");

    const response = await fetch(config.baseUrl, {
        method: 'GET',
        headers: myHeaders
    })
    return new Promise((resolve) => response.json()
        .then((json) => {
            json.status = response.status
            resolve(json)
        }))
}

export const verifyPin = async (pin, email_hash) => {
    var myHeaders = new Headers();
    myHeaders.append("Cache-Control", "no-cache");

    const response = await fetch(config.baseUrl + "v2/verify_pin/" + pin + "/" + email_hash, {
        method: 'GET',
        headers: myHeaders
    })
    return new Promise((resolve) => response.json()
        .then((json) => {
            json.status = response.status
            resolve(json)
        }))
}


export const registerByPinAPI = async (pin, email_hash, password, registerPartnerId, extension=false) => {
    var myHeaders = new Headers();
    myHeaders.append("Cache-Control", "no-cache");
    myHeaders.append("Content-Type", "application/json");

    const response = await fetch(config.baseUrl + "v2/register_by_pin/" + pin + "/" + email_hash, {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify({
            "password": password,
            "partner_id": registerPartnerId,
            "extension": extension
        })
    })
    return new Promise((resolve) => response.json()
        .then((json) => {
            json.status = response.status
            resolve(json)
        }))
}

export const getRewardProgress = async (userId) => {
    var myHeaders = new Headers();
    myHeaders.append("Cache-Control", "no-cache");

    const response = await fetch(config.baseUrl + "get_reward_progress/" + userId, {
        method: 'GET',
        headers: myHeaders
    })

    if (response.ok)
        return new Promise((resolve) => response.json()
            .then((json) => resolve(json.progress)))
    else return 0
}

export const getAvailableCodes = async (user_id = -1) => {
    var myHeaders = new Headers();
    myHeaders.append("Cache-Control", "no-cache");

    const response = await fetch(config.baseUrl + "available_codes?user_id=" + String(user_id), {
        method: 'GET',
        headers: myHeaders
    })
    return new Promise((resolve) => response.json()
        .then((json) => {
            json.status = response.status
            resolve(json)
        }))
}

export const getUserLocationFromAPI  = async (user_id) => {
    if ((!process.env.NODE_ENV || process.env.NODE_ENV === 'development') && true) {
        return new Promise((resolve) => resolve('US'))
    } else {
        var myHeaders = new Headers();
        myHeaders.append("Cache-Control", "no-cache");
        const response = await fetch(config.baseUrl + "get_country_code?user_id=" + String(user_id), {
            method: 'GET',
            headers: myHeaders
        })

        return new Promise((resolve) => response.json()
        .then((json) => {
            if (response.ok) {
                resolve(json.data)
            }
            else {
                resolve('US')
            }
        }))
    }
}

export const checkSupportAndroidVersion = () => {
    var ua = navigator.userAgent;
    var isAndroid = /(android)/i.test(ua)

    if (!isAndroid) { return false }
    var match = ua.toLowerCase().match(/android\s([0-9.]*)/i);
    if (!match) { return false }

    return true;
}
